module.exports = __webpack_public_path__ + "img/minus_button.26fb15cb.svg";